import { createDataProvider } from "./dataProvider";
const providers = {
  users: createDataProvider(
    `${process.env.REACT_APP_API_URL}/admin_user_list`,
    "user_id"
  ),

  support_messages: createDataProvider(
    `${process.env.REACT_APP_API_URL}/admin_support_messages`,
    "message_id"
  ),
};

export const combinedDataProvider = {
  getList: (resource, params) => providers[resource].getList(resource, params),

  getOne: (resource, params) => providers[resource].getOne(resource, params),

  getMany: (resource, params) => providers[resource].getMany(resource, params),

  getManyReference: (resource, params) =>
    providers[resource].getManyReference
      ? providers[resource].getManyReference(resource, params)
      : Promise.resolve({ data: [], total: 0 }),

  create: (resource, params) =>
    providers[resource].create
      ? providers[resource].create(resource, params)
      : Promise.reject(),

  update: (resource, params) =>
    providers[resource].update
      ? providers[resource].update(resource, params)
      : Promise.reject(),

  delete: (resource, params) =>
    providers[resource].delete
      ? providers[resource].delete(resource, params)
      : Promise.reject(),
};
